module.exports = __webpack_public_path__ + "img/icosphere.0cf50088.png";